



























import Cookies from 'js-cookie';

import { Component, Prop, Vue } from 'vue-property-decorator';
import { IndexStore } from '@/store/module/index';

import { GetUserInfo, LoginAdminLogout } from '@/http/api/LoginApi';

@Component
export default class Header extends Vue {
  // get uederInfo () {}
  @Prop({ default: 60 }) private height!: number;
  @Prop({ default: 2020 }) private width!: number;

  get userName() {
    return IndexStore.userInfo.nikeName;
  }
  private created() {
    this.getUserInfoFun();
  }
  // 获取用户资料
  private getUserInfoFun() {
    GetUserInfo().then((res) => {
      if (res.code === '000') {
        IndexStore.setUserInfo(res.result);
      }
    });
  }
  // 修改密码
  private set(): void {
    if (this.$route.name !== 'ChangePassword') {
      this.$router.push({ name: 'ChangePassword' });
    }
  }
  // 退出登录
  private quit(): void {
    this.$confirm('确定要退出吗?', '退出登录', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      Cookies.remove('token', { domain: '.cctaw.cn'});
      LoginAdminLogout().then((resp) => {
        if (resp.code === '000') {
          // 清除所有缓存
          window.localStorage.clear();

          // window.localStorage.setItem('token', '');
          // window.localStorage.setItem('user', '');
          // window.localStorage.setItem('email', '');
          // window.localStorage.setItem('userPermissions', '');
          this.$router.push({ path: '/login' });
        }
      });
    });
  }
}
